module.exports = __webpack_public_path__ + "static/media/gf.434bae07.svg";